import {
  ContactPersonsAction,
  SUCCESS_FETCH_CONTACT_PERSONS,
} from '../actions/contactPerson'

export type ContactPersonsState = {
  data: {
    id: number
    firstName: string
    lastName: string
  }[]
}

const init: ContactPersonsState = {
  data: [],
}

export default function contactPersons(
  state: ContactPersonsState = init,
  action: ContactPersonsAction
) {
  switch (action.type) {
    case SUCCESS_FETCH_CONTACT_PERSONS:
      return { ...state, data: action.payload.users }
  }

  return state
}
